<template>
    <vx-chart-categorical
        :loading="loading"
        :data="data"
        :colors="colors"
        :axis="{
            x: {
                key: 'count',
            },
        }"
    >
        <template v-slot:title> Recently Created Marketing Campaigns </template>
        <template v-slot:subtitle> Last 30 Days </template>
        <template v-slot:footer>
            <vx-button size="xs" href="/messaging/campaigns" outline color="muted-light">
                Go to Campaigns
                <font-awesome-icon widthAuto :icon="faArrowRight"></font-awesome-icon>
            </vx-button>
        </template>
    </vx-chart-categorical>
</template>

<script setup>
import { VxButton, VxChartCategorical } from '@voxie/frontend-components';
import { ref } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { campaignsClient } from '~/services';
import { uniqBy } from '~/utils/helpers';
import { getClientTz } from '../../utils/date';
import dayjs from '~/utils/dayjs';
import { CAMPAIGN_STATUSES } from '~/constants/campaign';

const loading = ref(true);
const data = ref([]);
const colors = ref([]);

campaignsClient
    .campaignsCountByStatus(Spark.state.currentTeam.id, {
        start_date: dayjs().tz(getClientTz()).subtract(30, 'days').utc().format('YYYY-MM-DD H:m:s'),
        end_date: dayjs().tz(getClientTz()).utc().format('YYYY-MM-DD H:m:s'),
        type: 'marketing',
    })
    .then((response) => {
        data.value = response.data.data.map((item) => {
            const status = CAMPAIGN_STATUSES[item.status] || CAMPAIGN_STATUSES.archived;

            const transparency = '4D';
            return {
                iconColor: status.hexColor,
                bgColor: status.hexColor + transparency,
                label: status.label,
                count: item.count,
            };
        });

        colors.value = uniqBy(data.value, 'label');
    })
    .finally(() => {
        loading.value = false;
    });
</script>
